package com.upcominds.expedite.data.auth

import com.upcominds.expedite.data.AppConfig

object AuthConfigProvider {
    val oidcConfig: OidcConfig get() = platformOidcConfig(AppConfig.keycloakUrl)

    fun mobileConfig(issuer: String) = OidcConfig(
        issuer = issuer,
        clientId = "expedite-mobile",
        redirectUri = "com.upcominds.expedite://oauth2redirect",
        scope = "openid profile email offline_access"
    )

    fun webConfig(issuer: String) = OidcConfig(
        issuer = issuer,
        clientId = "mobile-app",
        redirectUri = "com.upcominds.expedite://oauth2redirect",
        scope = "openid profile email"
    )
}

expect fun platformOidcConfig(issuer: String): OidcConfig
